import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2>About House of Canvas</h2>
        
        <p className="about-description">
          Established in 2010, House of Canvas is a leading tent manufacturer in East Africa.
          We specialize in designing and manufacturing premium quality tents for various
          applications including events, safaris, military, and commercial purposes.
        </p>
        
        <p className="about-description">
          With over a decade of experience, we've built a reputation for excellence in
          craftsmanship, innovative designs, and exceptional customer service across
          Tanzania and Kenya.
        </p>

        <div className="gallery-section1">
          <img src="/images/aboutSec.PNG" alt="Gallery" width="100%" height="100%" />
        </div>

        {/* <div className="gallery-grid"> */}
          {/* Left Column - Two large images */}
          {/* <div className="left-column">
            <div className="gallery-item">
              <img 
                src="/images/aboutImg1.jpg" 
                alt="Luxury tent at night with lighting"
                className="gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img 
                src="/images/aboutSmallImg1-min.JPG" 
                alt="Tent in landscape setting"
                className="gallery-image"
              />
            </div>
          </div> */}
          
          {/* Right Column - Grid of 4 small images + 1 large image */}
          {/* <div className="right-column">
            <div className="small-images-grid">
              <div className="gallery-item">
                <img 
                  src="/images/aboutSmallImg3.jpg" 
                  alt="Luxury tent interior with bed"
                  className="gallery-image"
                />
              </div>
              <div className="gallery-item">
                <img 
                  src="/images/aboutSmallImg5-min.jpg" 
                  alt="Tent exterior view"
                  className="gallery-image"
                />
              </div>
              <div className="gallery-item">
                <img 
                  src="/images/aboutSmallImg4-min.jpg" 
                  alt="Tent porch view"
                  className="gallery-image"
                />
              </div>
              <div className="gallery-item">
                <img 
                  src="/images/aboutSmallImg2-min.jpeg" 
                  alt="Outdoor gazebo tent"
                  className="gallery-image"
                />
              </div>
            </div>
            <div className="gallery-item large">
              <img 
                src="/images/aboutSmallImg-min.jpg" 
                alt="Tent among trees"
                className="gallery-image"
              />
            </div>
          </div>*/}
        {/* </div>  */}

        <button className="view-gallery-btn">View gallery</button>
      </div>
    </section>
  );
};

export default About; 